import {createSlice} from "@reduxjs/toolkit";

const initialReceiptsState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const receiptsSlice = createSlice({
  name: "receipts",
  initialState: initialReceiptsState,
  reducers: {
    receiptsFetched: (state, action) => {
      const {totalReceiptsCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalReceiptsCount = totalReceiptsCount;
      state.pageCount = pageCount;
    },
    receiptsAppended: (state, action) => {
      const {totalReceiptsCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalReceiptsCount = totalReceiptsCount;
      state.pageCount = pageCount;
    },
    cancelReceipt: (state, action) => {
      const {receiptID} = action.payload;
      const mappedArray = state.entities.map (item => item._id);
      const index = mappedArray.indexOf(receiptID);
      if (Boolean(state.entities)) {
        state.entities[index].cancaled = 1;
      }
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoicesError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
